import { createResourceSelectors } from "src/redux_resources_v1";
import { resourceNames } from "src/constants";

export const averageHealingIndexResourceSelector = createResourceSelectors(
  resourceNames.averageHealingIndex
);
